"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebDeepLinkHook = void 0;
class WebDeepLinkHook {
    constructor(props) {
        const { userAgent } = props;
        this._needFallbackToAppStore = this._getNeedFallbackToAppStore(userAgent);
    }
    afterCreate(oneLink) {
        oneLink.params.webDeepLink = this._needFallbackToAppStore
            ? 'https://itunes.apple.com/app/apple-store/id1498607143?pt=1613620&ct=interstitialdownload&mt=8'
            : 'https://play.google.com/store/apps/details?id=com.bd.nproject';
    }
    _getNeedFallbackToAppStore(userAgent) {
        const isIOS = /iP(hone|od|ad)/.test(userAgent);
        const isMacOS = /Macintosh/.test(userAgent);
        return isIOS || isMacOS;
    }
}
exports.WebDeepLinkHook = WebDeepLinkHook;
